import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import Header from './Header'
import Footer from './Footer'

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <>
        <Header offHome />
        <main
          className="pt-28 pb-20 px-6 min-h-[calc(100vh-64px-80px)]"
          aria-live="polite"
        >
          <div className="max-w-[420px] mx-auto flex items-center justify-center min-h-[200px]">
            <p className="text-text-muted text-sm">Chargement…</p>
          </div>
        </main>
        <Footer />
      </>
    )
  }

  if (!user) {
    const nextValue = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?next=${nextValue}`} replace />
  }

  return <>{children}</>
}
